import { render, staticRenderFns } from "./tabExternalProjectProgressReport.vue?vue&type=template&id=3924cf08&scoped=true&"
import script from "./tabExternalProjectProgressReport.vue?vue&type=script&lang=ts&"
export * from "./tabExternalProjectProgressReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3924cf08",
  null
  
)

export default component.exports